<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="330px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2"
        ><h5>{{ showText }}</h5></v-card-text
      >
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Ne"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        <el-button
          title="Taip"
          :loading="loading"
          @click.native="deleteData()"
          color="primary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'ModalDelete',
  mixins: [errorNotifications],
  props: {
    item: Object,
    value: Boolean,
    title: String,
    text: String,
    loading: Boolean,
    code: String,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.$t(this.title)
    },
    textByCode() {
      return this.notificationText(this.code)
    },
    showText() {
      return this.code ? this.textByCode : this.$t(this.text)
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
      this.uploadedFiles = []
      this.showModal = false
    },

    cancel() {
      this.closeModal()
    },

    deleteData() {
      this.$emit('confirmDelete', this.item)
    },
  },
}
</script>
<style lang="scss" scoped></style>
